import {
    TFundingRequirement,
    TFundingRequirementType
} from './fundingRequirements.types';

export const getFundingRequirement = (
    requirements: TFundingRequirement[],
    type: TFundingRequirementType
): TFundingRequirement | undefined =>
    requirements.find((requirement) => requirement.type === type);
